export const COOKIE_TOKEN = 'token'
export const FORUM_ORG_NEWS = 'ORG_NEWS'